import React = require('react');
import { IAuthState } from '../../../../../../services/auth/models';
import { IAuthActions } from '../../../../../../services/auth/reducer';
import { IMtaActions } from '../../../../../../services/mta/models';
import { withRouter } from 'react-router';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';

interface INavigation {
  location: any;
  isMobile: boolean;
  auth: IAuthState;
  claimsSSOEnabled: boolean;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
    mta: IMtaActions;
  }
}

const Navigation = ({ location, actions, isMobile, auth, claimsSSOEnabled }: INavigation) => {

  let policyTabSelected = false;
  let quoteTabSelected = false;
  let claimsTabSelected = false;
  let offersTabSelected = false;
  const handleRouteChange = (route: string) => () => {
    actions.push(route)
  }

  const claimsExternalUrl = auth?.claims?.url
  const showClaimsTab = auth?.claims?.showTab || false
  const url = auth?.claims?.url;

  if (location) {
    switch (location.pathname) {
      case '/account/summary':
        policyTabSelected = true;
        quoteTabSelected = false;
        claimsTabSelected = false;
        offersTabSelected = false;
        break;
      case '/account/quotes':
        policyTabSelected = false;
        quoteTabSelected = true;
        claimsTabSelected = false;
        offersTabSelected = false;
        break
      case '/account/claims':
        policyTabSelected = false;
        quoteTabSelected = false;
        claimsTabSelected = true;
        offersTabSelected = false;
        break;
      case '/account/offers':
        policyTabSelected = false;
        quoteTabSelected = false;
        claimsTabSelected = false;
        offersTabSelected = true;
        break;
    }
  }

  const renderClaimsTab = () => {

    const isSSo = claimsSSOEnabled && claimsExternalUrl !== undefined;
    let claimsFunc = handleRouteChange('/account/claims')

    if (showClaimsTab && isSSo && url) {
      claimsFunc = handleRedirect;
    }

    if (claimsSSOEnabled && !claimsExternalUrl) {
      return null;
    }

    return (
      <>
        <div className={claimsTabSelected ? 'claims-tab selected' : 'claims-tab'}
             onClick={claimsFunc}>CLAIMS
        </div>
      </>
    )
  }

  const handleRedirect = () => {
    window.open(url, '_blank');
  }

  return (
    <div className={isMobile ? 'header-navigation__mobile' : 'header-navigation'}>
      <div className={policyTabSelected ? 'policies-tab selected' : 'policies-tab'}
           onClick={handleRouteChange('/account/summary')}>POLICIES
      </div>
      <div className={quoteTabSelected ? 'quotes-tab selected' : 'quotes-tab'}
           onClick={handleRouteChange('/account/quotes')}>QUOTES
      </div>
      {renderClaimsTab()}
      <div className={offersTabSelected ? 'offers-tab selected' : 'offers-tab'}
           onClick={handleRouteChange('/account/offers')}>OFFERS
      </div>
    </div>
  )
}

export default flow([
  connect(
    (state: IStore) => ({}),
    (dispatch) => ({}),
  ),
  withRouter,
])(Navigation);
